import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAction, useQuery } from "convex/react";
import { toast } from "sonner";
import { api } from "./convex/_generated/api";

import "./PricingPage.css";

const PACKS = [
  {
    id: "premium",
    title: "HabitFlow Premium",
    price: "$20/mo",
    includes: [
      "Personalized habit recommendations",
      "Advanced habit and wellness tracking",
      "Daily progress insights",
      "Goal-based habit planning",
      "Consistency and streak analytics",
      "Progress dashboard with detailed insights",
      "Premium habit-building tools",
    ],
    color: "#4ade80",
    popular: true,
  },
];

export default function PricingPage() {
  const [checkoutLoading, setCheckoutLoading] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const sessionId =
    location.state?.sessionId ||
    localStorage.getItem("session_id");

  const [error, setError] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);

  const createCheckout = useAction(
    api.stripe.createCheckoutSessionTravel
  );

  const createPortal = useAction(
    api.stripe.createPortalSessionTravel
  );

  const user = useQuery(
    api.users.getUserBySession,
    sessionId
      ? { sessionId }
      : "skip"
  );

  const progress = useQuery( api.progress.getByUserId, user?._id ? 
        { userId: user._id } : "skip" );

  if (user?.role === "premium") {
    toast.success("You already have access!");

    localStorage.setItem(
      "session_id",
      sessionId
    );

    const userId = user?._id;

    

    if (progress?.length > 0) {
    navigate("/suggestions", {
      state: {
        userId,
      },
    });
  } else {
    navigate("/progress", {
      state: {
        sessionId,
      },
    });
  }
    



    //navigate("/traveldashboard", {
      //state: { sessionId },
    //});

    return;
  }

  const handleGetPack = async (packId) => {
    localStorage.setItem(
      "session_id",
      sessionId
    );

    if (!sessionId) {
      toast.error("Please sign in first");
      navigate("/");
      return;
    }

    setCheckoutLoading(packId);

    try {
      const { url } = await createCheckout({
        userId: user._id,
        email: user.email,
        packId: packId,
      });

      localStorage.setItem(
        "session_id",
        sessionId
      );

      window.location.href = url;
    } catch (err) {
      toast.error("Failed to start checkout");
    } finally {
      setCheckoutLoading(null);
    }
  };

  const handleManage = async (packId) => {
    setCheckoutLoading("portal");

    try {
      localStorage.setItem(
        "session_id",
        sessionId
      );

      const { url } = await createPortal({
        userId: user._id,
        packId,
      });

      window.location.href = url;
    } catch (err) {
      setError("Failed to open billing portal");
    } finally {
      setCheckoutLoading(null);
    }
  };

  function userHasPack(user, packId) {
    return (
      packId === "premium" &&
      user?.role === "premium"
    );
  }

  return (
    <section className="pricing-page">

      <div className="pricing-header">

        <div className="pricing-eyebrow">
          PREMIUM HABITS
        </div>

        <h2 className="pricing-section-title">
          Build better habits
        </h2>

        <p className="pricing-section-subtitle">
          Everything you need to create routines,
          stay consistent, and make meaningful progress.
        </p>

        <p className="pricing-section-note">
          All premium habit tools included in one
          subscription — $20/mo
        </p>

      </div>

      <div className="pricing-grid">

        {PACKS.map((pack) => (
          <div
            key={pack.id}
            className={`pricing-pack-card ${
              pack.popular
                ? "pricing-pack-card--popular"
                : ""
            }`}
          >

            {pack.popular && (
              <div className="pricing-popular-badge">
                Most Popular
              </div>
            )}

            <div
              className="pricing-pack-icon"
              style={{
                color: pack.color,
              }}
            >
              ✦
            </div>

            <h3 className="pricing-pack-title">
              {pack.title}
            </h3>

            <div
              className="pricing-pack-price"
              style={{
                color: pack.color,
              }}
            >
              {pack.price}
            </div>

            <div className="pricing-includes">

              {pack.includes.map((item, i) => (
                <div
                  key={i}
                  className="pricing-include-item"
                >
                  <span className="pricing-check">
                    ✓
                  </span>

                  <span>{item}</span>
                </div>
              ))}

            </div>

            {userHasPack(user, pack.id) ? (

              <div className="pricing-active-wrapper">

                <div className="pricing-active">
                  ✓ Active
                </div>

                <button
                  disabled={true}
                  onClick={() =>
                    handleManage(pack.id)
                  }
                  className="pricing-cancel-button"
                >
                  Cancel Subscription
                </button>

              </div>

            ) : (

              <button
                disabled={true}
                onClick={() =>
                  handleGetPack(pack.id)
                }
                className="pricing-get-button"
              >
                Get Premium →
              </button>

            )}

          </div>
        ))}

      </div>

    </section>
  );
}
